import { api } from "./api";
import { ISource } from "./sources";

const listSources = async ({ knowledgeId }: { knowledgeId: number }): Promise<ISource[]> => {
  const url = `/knowledge/${knowledgeId}/sources`;
  const response = await api.get(url);
  return response.data;
};

export const knowledgeService = {
  listSources,
};
